import {
  BodyDefaultTypography,
  Box,
  H4,
  InterZellerMediumFont,
} from '@npco/zeller-design-system'
import styled from 'styled-components'

import { BREAKPOINT } from 'styles/breakpoints'

export const StyledDepositDetails = styled.div`
  width: 385px;
  height: 100%;
  overflow-y: auto;

  @media screen and (max-width: ${BREAKPOINT.XS - 1}px) {
    width: 100vw;
  }
`

export const DepositDetailsContainer = styled.div`
  width: calc(100vw - 2rem);
  height: 100%;

  @media screen and (min-width: ${BREAKPOINT.XS}px) {
    width: 100%;
  }
`

export const StyledContentWrapper = styled.div`
  padding-bottom: 96px;
`

export const StyledDetailsContainer = styled.div`
  padding: 2rem 1.5rem 0;
`

export const StyledAmountContainer = styled.div`
  margin: 2.5rem 0 0;
  padding: 0 0.5rem;
`

export const StyledAmountBadge = styled.div`
  width: auto;
  padding: 1rem;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.BLUE_80};
`

export const StyledDetailsTitle = styled(H4)`
  margin: 1.5rem 0 1rem;
  color: ${({ theme }) => theme.colors.BLACK_900};
`

export const StyledDepositDateTitle = styled(H4)`
  margin: 0;
  color: ${({ theme }) => theme.colors.BLUE_1000};
`

export const StyledDetailsLabel = styled.span`
  color: ${({ theme }) => theme.colors.BLACK_900};
  ${BodyDefaultTypography};
  ${InterZellerMediumFont};
`

export const StyledDetailsValue = styled.div`
  max-width: 60%;
  text-align: right;
  color: ${({ theme }) => theme.colors.BLACK_900};
  ${BodyDefaultTypography}
`

export const TooltipContent = styled(Box)`
  max-width: 368px;
  text-align: center;
`
